"use client";

import { useEffect } from "react";
import { captureErrorBoundary } from "@/lib/utils/captureErrorBoundary";

export default function BlogError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    captureErrorBoundary(error, "blog", "/blog");
  }, [error]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-5">
      <div className="text-center max-w-md">
        <h2 className="text-2xl font-semibold text-[var(--text-primary)] mb-4">
          Something went wrong
        </h2>
        <p className="text-[var(--text-muted)] mb-6">
          We had trouble loading this page. Please try again.
        </p>
        <button
          onClick={reset}
          className="px-6 py-2.5 rounded-lg bg-[var(--brand)] text-white text-sm font-medium hover:opacity-90 transition-opacity"
        >
          Try Again
        </button>
      </div>
    </div>
  );
}
